/**
 * Textos (`en`) del tall «suppliers» de Qualitat i APPCC (OBR-166, supplier approval). Tall propi: no es toca
 * `en.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const suppliersEn = {
  'backoffice.qualitySuppliers': {
    // Approval statuses (list, filter, history, warnings).
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusNotApproved: 'Not approved',
    statusSuspended: 'Suspended',

    // Supplier list: column and filter.
    colHomologation: 'Approval',
    filterHomologation: 'Approval',
    filterAll: 'All statuses',
    rowHomologation: 'Approval',

    // «Approval» section of the supplier dialog.
    sectionTitle: 'Approval',
    sectionHint:
      'The supplier’s trust status, its documents and how it has changed. A supplier that is not approved is a warning on the order and at reception, never a block.',
    sectionNewHint: 'You will be able to approve the supplier once you have saved it.',
    sectionLoadError: 'The approval of this supplier could not be loaded.',
    dialogTitle: 'Approval of {{name}}',
    dialogClose: 'Close',
    currentStatus: 'Current status',
    statusDate: 'Date',
    statusBy: 'Responsible',
    statusNeverChanged: 'Not decided yet',
    statusUnknownPerson: 'Unknown person',
    readOnlyHint: 'Only administration or quality can change the status.',

    // Changing the status (reason required).
    changeStatus: 'Change status',
    changeTitle: 'Change the approval status',
    changeBody:
      'The supplier moves from “{{from}}” to the status you choose. The change and its reason stay in the history and cannot be deleted.',
    changeTarget: 'New status',
    changeReasonLabel: 'Reason for the change (required)',
    changeReasonPlaceholder: 'Why it changes: audit done, certificate expired, serious incident…',
    changeConfirm: 'Change status',
    changeErrorForbidden: 'You do not have permission to change the approval status.',
    changeErrorReason: 'The reason for the change is required.',
    changeErrorNotFound: 'This supplier no longer exists or has been deactivated.',
    changeError: 'The status could not be changed. Please try again.',

    // Observations.
    notesLabel: 'Observations',
    notesHint: 'Conditions, audit outcome… They are saved apart from the rest of the record, with their own button.',
    notesSave: 'Save observations',
    notesSaved: 'Observations saved.',
    notesError: 'The observations could not be saved. Please try again.',

    // Status change history.
    historyTitle: 'Change history',
    historyEmpty: 'No status change has been recorded yet.',
    historyWhen: 'When',
    historyFrom: 'From',
    historyTo: 'To',
    historyReason: 'Reason',
    historyWho: 'Who',

    // Documents.
    documentsTitle: 'Documents',
    documentsHint: 'The health registration (RGSEAA) and, if it has them, certificates such as IFS, BRC or organic.',
    documentsEmpty: 'There are no documents yet.',
    documentsLoadError: 'The documents could not be loaded.',
    documentsReadOnlyHint: 'Documents can only be managed by administration, quality and purchasing.',
    addDocument: 'Add a document',
    editDocument: 'Edit',
    deleteDocument: 'Deactivate',
    openFile: 'Open file',
    openFileFor: 'Open the file of {{name}}',
    openFileError: 'The file could not be opened. Please try again.',
    colDocName: 'Document',
    colDocIssued: 'Issued',
    colDocExpires: 'Expiry',
    colDocState: 'Status',
    colDocFile: 'File',
    colDocActions: 'Actions',
    docTypeSanitaryRegistry: 'Health registration',
    docTypeCertificate: 'Certificate',
    noFile: 'No file',

    // Document expiry.
    expiryValid: 'Valid',
    expiryExpiring: 'Expiring soon',
    expiryExpired: 'Expired',
    expiryNone: 'No expiry',
    expiryExpiringIn_one: 'Expires in {{count}} day',
    expiryExpiringIn_other: 'Expires in {{count}} days',
    expiryExpiringToday: 'Expires today',
    expiryExpiredAgo_one: 'Expired {{count}} day ago',
    expiryExpiredAgo_other: 'Expired {{count}} days ago',

    // Document dialog.
    docAddTitle: 'Add a document',
    docEditTitle: 'Edit the document',
    docType: 'Type',
    docName: 'Name',
    docNameHint: 'For example: RGSEAA, IFS, BRC, Organic.',
    docNumber: 'Number',
    docIssued: 'Issue date',
    docExpires: 'Expiry date',
    docExpiresHint: 'Leave blank if the document does not expire.',
    docNotes: 'Notes',
    docFile: 'File',
    docFileHint: 'PDF or image, up to 10 MB.',
    docFileCurrent: 'Saved file: {{name}}',
    docFileChosen: 'Chosen file: {{name}}',
    docSave: 'Save document',
    docErrorName: 'The document needs a name.',
    docErrorDates: 'The expiry date cannot be earlier than the issue date.',
    docErrorInvalidType: 'The file must be a PDF or an image.',
    docErrorTooLarge: 'The file is larger than 10 MB.',
    docErrorUpload: 'The file could not be uploaded. Please try again.',
    docErrorSave: 'The document could not be saved. Please try again.',
    docErrorNoTenant: 'The obrador of the file could not be determined. Please sign in again.',

    // Deactivating a document (reason required).
    docDeleteTitle: 'Deactivate the document',
    docDeleteBody:
      'The document stops showing on the supplier’s record, but it stays on file. A written reason is required.',
    docDeleteConfirm: 'Deactivate',
    docDeleteError: 'The document could not be deactivated. Please try again.',

    // Warnings that never block (order, sending, reception).
    warnOrderPending:
      'This supplier is not approved yet (pending status). You can go on, but its approval should be decided.',
    warnOrderNotApproved:
      'This supplier is not approved. You can go on, but check that it is the supplier you want to use.',
    warnOrderSuspended:
      'This supplier is suspended. You can go on, but check that it is the supplier you want to use.',
    warnReceptionNotApproved:
      'This supplier is not approved. You can still register the reception, but check the goods carefully.',
    warnReceptionSuspended:
      'This supplier is suspended. You can still register the reception, but check the goods carefully.',
  },
} as const;
